module.exports = __webpack_public_path__ + "static/media/logo-dr-august-oetker-kg-1x.dfcdfddc.png";